const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/permitir-lancar-quantidade-de-aulas-ministradas-e-planejadas",
    name: "permitir-lancar-quantidade-de-aulas-ministradas-e-planejadas",
    meta: {
      allowedPermissions: ["buscar_disciplinas"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarQuantidadeDeAulasMinistradasEPlanejadas/PermitirLancarQuantidadeDeAulasMinistradasEPlanejadasHome.vue"
      ),
  },
  {
    path: "/permitir-lancar-quantidade-de-aulas-ministradas-e-planejadas/:areaDisciplinaId/:ensinoId/:faseId/:turno/:turmaId/:periodoId/editar",
    name: "permitir-lancar-quantidade-de-aulas-ministradas-e-planejadas-editar",
    meta: {
      allowedPermissions: [
        "controle_avaliacao_create",
        "carregar_infos_cadastro",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarQuantidadeDeAulasMinistradasEPlanejadas/PermitirLancarQuantidadeDeAulasMinistradasEPlanejadasEditar.vue"
      ),
  },
];

export default routes;
